import { useState } from 'react';
import { Settings, LayoutGrid, ArrowLeft, ArrowRight } from 'lucide-react';
import './styles/PlatformConfiguration.css';

interface GroupDashboardConfigProps {
  nextStep: () => void;
  previousStep: () => void;
}

interface SectionItem {
  key: string;
  title: string;
  description: string;
}

const sections: SectionItem[] = [
  {
    key: 'kpiSummaryRow',
    title: 'KPI Summary Row',
    description: 'Total subsidiaries, group compliance score, escalations, and overdue items',
  },
  {
    key: 'subsidiaryCards',
    title: 'Subsidiary Cards',
    description: 'Individual company cards with health status, compliance %, and overdue counts',
  },
  {
    key: 'needsAttentionPanel',
    title: 'Needs Attention Panel',
    description: 'Highlighted list of companies with issues requiring immediate action',
  },
  {
    key: 'groupHierarchyStrip',
    title: 'Group Hierarchy Strip',
    description: 'Visual strip showing holding · companies · branches structure',
  },
];

const GroupDashboardConfig = ({ nextStep, previousStep }: GroupDashboardConfigProps) => {
  const [toggles, setToggles] = useState<Record<string, boolean>>({
    kpiSummaryRow: true,
    subsidiaryCards: true,
    needsAttentionPanel: true,
    groupHierarchyStrip: true,
  });

  const handleToggle = (key: string) => {
    setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="organization-wrapper">
      {/* Header */}
      <div className="organization-inner">
        <div className="organization-header">
          <div className="organization-icon">
            <Settings className="organization-icon-svg" />
          </div>

          <div className="organization-text">
            <h2 className="organization-title">Group Dashboard Configuration</h2>

            <p className="organization-subtitle">Configure Group Dashboard sections</p>
          </div>
        </div>
      </div>

      {/* Info Banner */}
      <div className="group-dashboard-banner">
        <LayoutGrid size={16} className="group-dashboard-banner-icon" />
        <span className="group-dashboard-banner-text">Configure with sections appear on the Group Dashboard.</span>
      </div>

      {/* Section Rows */}
      <div className="group-dashboard-list">
        {sections.map((section) => (
          <div className="group-dashboard-row" key={section.key}>
            <div className="group-dashboard-row-text">
              <h3 className="group-dashboard-row-title">{section.title}</h3>
              <p className="group-dashboard-row-description">{section.description}</p>
            </div>

            <button
              type="button"
              role="switch"
              aria-checked={toggles[section.key]}
              className={`group-dashboard-toggle ${toggles[section.key] ? 'group-dashboard-toggle-on' : ''}`}
              onClick={() => handleToggle(section.key)}
            >
              <span className="group-dashboard-toggle-knob" />
            </button>
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div className="organization-footer">
        {/* Back */}
        <button onClick={previousStep} className="organization-back-btn">
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>

        <div className="organization-footer-right">
          {/* Next */}
          <button onClick={nextStep} className="organization-next-btn">
            <span>Next</span>
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupDashboardConfig;
